import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { useAuth } from '../auth/AuthContext.js';
import { NEW_ORDER_PATH } from '../components/StartNewOrderButton.js';

export function Home(): JSX.Element {
  const auth = useAuth();
  const { t } = useTranslation('common');
  if (auth.status === 'signed_in') {
    return (
      <div className="card">
        <h2>{t('home.welcomeBack')}</h2>
        <p>
          <Trans
            i18nKey="home.welcomeBody"
            t={t}
            components={[
              <Link key="orders" to="/quotes" />,
              <Link key="new" to={NEW_ORDER_PATH} />,
            ]}
          />
        </p>
      </div>
    );
  }
  return (
    <div className="card">
      <h2>{t('home.title')}</h2>
      <p>{t('home.tagline')}</p>
      <p>
        <Trans
          i18nKey="home.signedOutCta"
          t={t}
          components={[
            <Link key="signin" to="/login" />,
            <Link key="register" to="/register" />,
          ]}
        />
      </p>
    </div>
  );
}
